import React, { useEffect, useState } from "react";
import { buldingiconpng } from "../../../../assets/ImageExports";
import { data } from "react-router-dom";

const CompanyManagement = () => {
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    const data = localStorage.getItem("user");
    if (data) {
      setUserInfo(JSON.parse(data)); 
    }
  }, []);

  return (
    <div>
      <div className="container py-4">
        <div className="mb-4 d-flex ">
          <div
            style={{
              width: 100,
              height: 100,
              backgroundColor: "#e9ecef",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 8,
            }}
          >
            <img src={buldingiconpng} />
          </div>
          <div style={{ marginLeft: "20px" }}>
            <h5 className="mt-3 mb-1">{userInfo?.member_firm_name}</h5>
            <p className="text-muted">{userInfo?.member_business_type}</p>
          </div>
        </div>

        <form>
          <div className="mb-3">
            <label className="form-label">Address</label>
            <input
              type="text"
              className="form-control rounded-pill"
              defaultValue={userInfo?.member_firm_address}
            />
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">City</label>
              <input
                type="text"
                className="form-control rounded-pill"
                defaultValue={userInfo?.member_city}
              />
            </div>
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">District</label>
              <input
                type="text"
                className="form-control rounded-pill"
                defaultValue={userInfo?.member_city}
              />
            </div> */}
          </div>

          <div className="row">
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">Country</label>
              <input
                type="text"
                className="form-control rounded-pill"
                defaultValue={userInfo?.member_state}
              />
            </div> */}
            <div className="col-md-6 mb-3">
              <label className="form-label">State</label>
              <input
                type="text"
                className="form-control rounded-pill"
                defaultValue={userInfo?.member_state}
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Pincode</label>
            <input
              type="text"
              className="form-control rounded-pill"
              defaultValue={userInfo?.member_pin}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanyManagement;
